import { render, staticRenderFns } from "./Forex.vue?vue&type=template&id=5c4153e8&scoped=true"
import script from "./Forex.vue?vue&type=script&lang=js"
export * from "./Forex.vue?vue&type=script&lang=js"
import style0 from "./Forex.vue?vue&type=style&index=0&id=5c4153e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4153e8",
  null
  
)

export default component.exports